import React from "react";
import Logo from "../../../../../assets/images/commonImages/Company logo/33028722_7941436.jpg";

const Contacts = ({ data }) => {
  return (
   <div className="p-6 bg-white border-2 border-gray-300 rounded-md w-full mx-auto">
  <h2 className="text-lg font-medium mb-4 text-[#333333]">Contacts</h2>

  <div className="flex justify-around items-center text-sm">

    {/* Column 1: Logo */}
    <div className="flex flex-col items-center gap-2">
      <img
        src={Logo}
        alt="Company Logo"
        className="w-20 h-20 rounded-full border"
      />
      <p className="text-[#333333] font-medium text-sm">COMPANY LOGO</p>
    </div>

    {/* Divider */}
    <div className="h-20 w-px bg-gray-300"></div>

    {/* Column 2: Email + Status */}
    <div className="flex flex-col gap-2 items-start">
      <p>
        <span className="font-medium text-[#333333]">Email: </span>
     abucr@gmail.com
      </p>
      <span
        className={`px-4 py-1 text-sm ${
          data.status === "Active"
            ? "bg-green-100 text-green-700"
            : "bg-green-100 text-green-700"
        } rounded-md`}
      >
       Active
      </span>
    </div>

    {/* Divider */}
    <div className="h-20 w-px bg-gray-300"></div>

    {/* Column 3: Mobile + Subscription */}
    <div className="flex flex-col gap-2 items-start">
      <p>
        <span className="font-medium text-[#333333]">Mobile: </span>
 +91- 987654321
      </p>
      <p>
        <span className="font-medium text-[#333333]">
          Present Subscription:{" "}
        </span>
        Monthly 50
      </p>
    </div>
  </div>
</div>

  );
};

export default Contacts;
